import { render, staticRenderFns } from "./TabRounded.vue?vue&type=template&id=b472826e&"
import script from "./TabRounded.vue?vue&type=script&lang=js&"
export * from "./TabRounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports